<template >
  <div class="firePower">
    消防电源
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.firePower {
  border: 1px solid red;
}
</style>